(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pe-review-style"] && !Shopify.designMode) return;
  try {
    (() => {
  const connected = new WeakSet();
  function connectReviews() {
    document.querySelectorAll('.pe-pdp-reviews').forEach(container => {
      if (connected.has(container)) return;
      connected.add(container);
      function update() {
        const widget = container.querySelector('#klaviyo-product-reviews-wrapper');
        const count = widget?.querySelector('#kl_reviews_tabs__reviews_tab small')?.textContent.trim();
        const average = widget?.querySelector('.kl_reviews__summary__average_value')?.textContent.trim();
        const empty = count === '0' && average === '0' && widget.querySelectorAll('[role=tab]').length === 1 && Boolean(widget.querySelector('.kl_reviews__list_empty_state'));
        container.toggleAttribute('data-pe-reviews-empty', empty);
      }
      update();
      new MutationObserver(update).observe(container, {childList: true, subtree: true, characterData: true});
    });
  }
  connectReviews();
  document.addEventListener('shopify:section:load', connectReviews);
})();
  } catch(e) { console.error(e); }
})();

})();
